import axios from 'axios'
import store from '../store/index'
import router from '../router'

const baseURL = store.state.BASE_URL
let simulateMode = false

export const request = axios.create({
  baseURL: baseURL,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
  }

})


let flag = true

function repeatControll(func) {
  if (flag) {
    flag = false
    func()
    setTimeout(() => {
      flag = true
    })
  }
}

function requestError(error) {
  return Promise.reject(error || '')
}

function responseError(error) {
  const res = error?.response || {}

  if (res.status == 401) {
    localStorage.removeItem('ALESS_MINI_SH')
    repeatControll(() => {
      // ElMessage.error(res?.data?.message || res.statusText || 'error');
      ElMessage.error('请先登录');

    })

  }

  if (res?.data?.code == 400001) {
    repeatControll(() => {
      ElMessage.error(res.data.message);
      localStorage.removeItem('loginedMeetingId')
      localStorage.removeItem('ALESS_MINI_SH')
    })
  } else {
    repeatControll(() => {
      ElMessage.error(res?.data?.message || 'error');
    })
  }
  return Promise.reject(error || '')
}

let invalid = false;
let timer  = null
function resInterceptors(res) {
  // console.log(res)
  if (simulateMode) {

    return {
      msg: '测试模式',
      data: {
        a: 1,
        b: 2,
        c: [1, 2, 3]
      }
    }
  }
  if (res.data.code == 400) {
    if (!invalid) {
      invalid = true
      ElMessage.error(res.data.message || '服务异常，请联系管理员');
    }
  }
  if (res.headers.authorization) {
    localStorage.ALESS_MINI_SH = res.headers.authorization
  }
  
  if (res.data && res.data.msg === '请先登录') {
    return res.data
  } else {
    return res.data || {}
  }

}

function reqInterceptors(config) {
  const _config = config

  const token = localStorage.ALESS_MINI_SH || ''
  _config.headers['authorization'] = token


  return _config
}

request.interceptors.request.use(reqInterceptors, requestError)
request.interceptors.response.use(resInterceptors, responseError)



const pluginAxios = {
  install: function (Vue) {
    Object.defineProperty(Vue.config.globalProperties, '$axios', { value: request })
  }
}
export default pluginAxios
